/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextBookVo model module.
   * @module clazz_course/model/TextBookVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookVo</code>.
   * @alias module:clazz_course/model/TextBookVo
   * @class
   * @param id {Integer} id
   * @param title {String} 书名
   */
  var exports = function(id, title) {
    var _this = this;

    _this['id'] = id;
    _this['title'] = title;



  };

  /**
   * Constructs a <code>TextBookVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/TextBookVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/TextBookVo} The populated <code>TextBookVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUri')) {
        obj['thumbUri'] = ApiClient.convertToType(data['thumbUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'infoUrl')) {
        obj['infoUrl'] = ApiClient.convertToType(data['infoUrl'], 'String');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 封面
   * @member {String} thumbUri
   */
  exports.prototype['thumbUri'] = undefined;
  /**
   * 简介
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 教材简介url
   * @member {String} infoUrl
   */
  exports.prototype['infoUrl'] = undefined;



  export default exports;
;


